module.exports = __webpack_public_path__ + "static/media/firefox_default_search_walkthrough.c3329850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/firefox_default_search_walkthrough.png
// module id = 280
// module chunks = 0